<ng-container *ngIf="config">
        <xs-panel [config]="config"></xs-panel>
    </ng-container>